import { render, staticRenderFns } from "./user-details.html?vue&type=template&id=7dcf96dc&scoped=true&"
import script from "./user-details.js?vue&type=script&lang=js&"
export * from "./user-details.js?vue&type=script&lang=js&"
import style0 from "./user-details.scss?vue&type=style&index=0&id=7dcf96dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcf96dc",
  null
  
)

export default component.exports